import Subject from "../cse4sub/Subject";
import React from 'react'

export default function Cd() {
  return (
    <div>
       <Subject title="Electronic Devices Lab(ECE302)"
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}